/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class e{constructor(e,m,t){this.maximumTotalNumberOfVertices=e,this.maximumNumberOfFeatures=m,this.averageSymbolComplexity=t}}export{e as DisplayFeatureLimit};
